<!-- 物资信息 -->
<template>
  <div>
    <avue-crud ref="crud" v-model="form" :option="option" :table-loading="loading" :data="data" :page.sync="page"
      :search.sync="query" :defaults.sync="defaults" @row-save="rowSave" @row-update="rowUpdate" @row-del="rowDel"
      @search-change="searchChange" @search-reset="searchReset" @refresh-change="refreshChange" :beforeOpen="beforeOpen"
      @current-change="currentChange" @size-change="sizeChange" @on-load="onLoad">
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from "@/mixins/crud-mixins";
import { getList, add, update, remove, getDetail } from "./api";
import { searchTimeConfig } from "@/basic-common/util/common";

export default {
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList, add, update, remove, getDetail },
      option: {
        ...this.$store.state.publicOption,
      labelWidth: 140,
        column: [
          {
            label: '物资名称',
            prop: 'cargoName',
            search: true, // 查询是否显示
            type: 'select',
            remote: true,
            allowCreate: true,
            dicUrl: '/api/produce/vardict/select/distinct/pycode?varName={{key}}',
            props: {
              label: 'varName',
              value: 'id'
            },
          },
          {
            label: '当前库存量(吨)',
            prop: 'currentInventory',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '日运输量(吨)',
            prop: 'dailyTransport',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            addDisplay: false,
            editDisplay: false,
          },
          {
            label: '月运输量(吨)',
            prop: 'monthTransport',
            type: 'number',
            precision: 2,
            min: 0.01,
            max: 99999,
            addDisplay: false,
            editDisplay: false,
          },
          {
            ...searchTimeConfig,
            paramsKey: ["startTime", "endTime"],
          },
        ]
      },
    }
  }
}
</script>
<style scoped lang="scss"></style>
